// src/components/profile/OrderHistory.tsx
import React, { useState } from 'react';
import { useCart } from '../../context/CartContext';
import OrderCard from './OrderCard';

const OrderHistory: React.FC = () => {
  const { orders, loading, error } = useCart();
  const [activeTab, setActiveTab] = useState<'all' | 'pending' | 'confirmed' | 'delivered'>('all');

  const filteredOrders = orders.filter((order) => {
    if (activeTab === 'all') return true;
    return order.status.toLowerCase() === activeTab;
  });

  return (
    <div>
      <h1 className="text-3xl font-heading font-bold mb-6">Order History</h1>
      
      {/* Tabs */}
      <div className="flex border-b border-neutral-200 mb-6">
        {['all', 'pending', 'confirmed', 'delivered'].map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab as any)}
            className={`px-4 py-2 -mb-px font-medium text-sm capitalize ${
              activeTab === tab
                ? 'border-b-2 border-primary text-primary'
                : 'text-neutral-600 hover:text-neutral-900'
            }`}
          >
            {tab}
          </button>
        ))}
      </div>

      {error && <div className="text-error mb-4">{error}</div>}
      {loading ? (
        <div className="flex items-center justify-center h-64">Loading...</div>
      ) : filteredOrders.length === 0 ? (
        <p className="text-neutral-600">No orders found for this status.</p>
      ) : (
        <div className="grid gap-4">
          {filteredOrders.map((order) => (
            <OrderCard key={order.id} order={order} />
          ))}
        </div>
      )}
    </div>
  );
};

export default OrderHistory;